import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ role }) => {
  // =========================
  // ADMIN CHECK
  // =========================
  if (role === "admin") {
    const adminToken = localStorage.getItem("adminToken");
    const loggedInAdmin = localStorage.getItem("loggedInAdmin");

    if (!adminToken || !loggedInAdmin) {
      return <Navigate to="/admin-login" replace />;
    }

    return <Outlet />;
  }

  // =========================
  // SELLER CHECK
  // =========================
  if (role === "seller") {
    const sellerToken = localStorage.getItem("sellerToken");
    const loggedInSeller = localStorage.getItem("loggedInSeller");

    if (!sellerToken || !loggedInSeller) {
      return <Navigate to="/seller-login" replace />;
    }

    return <Outlet />;
  }

  // =========================
  // UNKNOWN ROLE
  // =========================
  return <Navigate to="/" replace />;
};

export default ProtectedRoute;